<div class="container-fluid p-0">
  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
    <div class="card rounded-0">
      <div class="card-body">

        <div class="row pt-3">
          <div class="col-12 col-xl-6">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Name</mat-label>
              <input
                matInput
                placeholder="Name"
                [(ngModel)]="site.name"
                name="name"
                type="text"
                #name
                required
                id="site_name" />
              <mat-error *ngIf="!name.valid">
                Please enter a {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} name.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="!site.id">
              <mat-label>Address / Address Lookup</mat-label>
              <input
                matInput
                placeholder="Address / Address Lookup"
                [(ngModel)]="site.location"
                (ngModelChange)="onAddressInputChange($event)"
                [matAutocomplete]="addressAuto"
                name="location"
                id="location"
                #location
                type="text"
                required />
              <mat-autocomplete #addressAuto="matAutocomplete">
                <mat-option
                  *ngFor="let prediction of addressPredictions"
                  [value]="prediction.label"
                  (onSelectionChange)="$event.isUserInput && onSelectPrediction(prediction)">
                  {{ prediction.label }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="!location.valid">Please enter a location / physical address.</mat-error>
            </mat-form-field>

            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Type</mat-label>
                  <mat-select
                    placeholder="Type"
                    [(ngModel)]="site.site_type"
                    name="site_type" required
                    id="site_type">
                    <mat-option [value]="siteType" *ngFor="let siteType of site_types">{{siteType}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Status</mat-label>
                  <mat-select
                    placeholder="Status"
                    [(ngModel)]="site.site_status"
                    name="site_status"
                    required
                    id="site_status">
                    <mat-option *ngFor="let site_status of site_statuses" value="{{ site_status }}">
                      {{ site_status }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Is Logbook (BC Group)</mat-label>
                  <mat-select
                    placeholder="Is Logbook (BC Group)"
                    [(ngModel)]="site.is_logbook"
                    name="is_logbook"
                    required
                    id="is_logbook">
                    <mat-option [value]="0">No</mat-option>
                    <mat-option [value]="1">Yes</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="!site.id">
                  <mat-label>Max Geofence Size</mat-label>
                  <input
                    matInput
                    placeholder="Max Geofence Size"
                    [(ngModel)]="site.max_geofence_size"
                    name="max_geofence_size"
                    type="number"
                    id="max_geofence_size" />
                  <mat-hint>Enter max geofence size here.</mat-hint>
                </mat-form-field>
              </div>
            </div>

          </div>

          <div class="col-12 col-xl-6">

            <div class="row">
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Job #</mat-label>
                  <input
                    matInput
                    placeholder="Job #"
                    [(ngModel)]="site.external_reference"
                    name="external_reference"
                    type="text"
                    id="external_reference" />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Risk Level</mat-label>
                  <mat-select
                    placeholder="Risk Level"
                    [(ngModel)]="site.site_risk_assessment"
                    name="site_risk_assessment"
                    required
                    id="site_risk_assessment">
                    <mat-option *ngFor="let site_risk_assessmen of site_risk_assessments" [value]="site_risk_assessmen">
                      {{ site_risk_assessmen | titlecase }}
                    </mat-option>
                  </mat-select>
                  <mat-hint>The risk level will only show when it is enabled in the settings.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <app-datetime-picker
                  [selectedDateTime]="siteOpenTime"
                  [isRequired]="true"
                  [pickerName]="'open_time'"
                  [pickerType]="'timer'"
                  [label]="'Opening Time'"
                  [hint]="'Click the clock icon to select a time.'"
                  [selectTooltip]="'Select the opening time.'"
                  [removeTooltip]="'Remove the opening time.'"
                  [errorText]="'Please select a opening time.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputOpeningTimeDetails($event)"></app-datetime-picker>
              </div>
              <div class="col-6">
                <app-datetime-picker
                  [selectedDateTime]="siteCloseTime"
                  [isRequired]="true"
                  [pickerName]="'close_time'"
                  [pickerType]="'timer'"
                  [label]="'Closing Time'"
                  [hint]="'Click the clock icon to select a time.'"
                  [selectTooltip]="'Select the closing time.'"
                  [removeTooltip]="'Remove the closing time.'"
                  [errorText]="'Please select a closing time.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputClosingTimeDetails($event)"></app-datetime-picker>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="full-width mb-4">
                  <mat-slide-toggle [(ngModel)]="site.enable_after_hours_notification" name="enable_after_hours_notification">
                    Enable after hours notifications.
                  </mat-slide-toggle>
                </div>
              </div>
              <div class="col">
                <app-timezone-select [timezoneInput]="site.timezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
              </div>
            </div>

            <div class="row" *ngIf="showProjectStartEndDates(site.site_status)">
              <div class="col">
                <app-datetime-picker
                  [selectedDateTime]="estimatedProjectStartDate"
                  [pickerName]="'estimatedProjectStartDate'"
                  [label]="'Estimated Start Date'"
                  [hint]="'Click the calendar icon to select a date and time.'"
                  [selectTooltip]="'Select the estimated start date.'"
                  [removeTooltip]="'Remove the estimated start date.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputStartDateTimeDetails($event)"></app-datetime-picker>
              </div>

              <div class="col">
                <app-datetime-picker
                  [selectedDateTime]="estimatedProjectEndDate"
                  [pickerName]="'estimatedProjectEndDate'"
                  [label]="'Estimated End Date'"
                  [hint]="'Click the calendar icon to select a date and time.'"
                  [selectTooltip]="'Select the estimated end date.'"
                  [removeTooltip]="'Remove the estimated end date.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputEndDateTimeDetails($event)"></app-datetime-picker>
              </div>
            </div>

<!--            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="!site.id">-->
<!--              <mat-label>Is Logbook (BC Group)</mat-label>-->
<!--              <mat-select-->
<!--                placeholder="Is Logbook (BC Group)"-->
<!--                [(ngModel)]="site.is_logbook"-->
<!--                name="is_logbook_bc"-->
<!--                required-->
<!--                id="is_logbook_bc">-->
<!--                <mat-option [value]="0">No</mat-option>-->
<!--                <mat-option [value]="1">Yes</mat-option>-->
<!--              </mat-select>-->
<!--            </mat-form-field>-->

          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <button
              mat-raised-button
              [disabled]="!f.valid || inProgress || site.geofence_size > site.max_geofence_size"
              (click)="onSubmit(f)"
              type="button"
              color="primary"
              class="my-2 ml-0 mr-2">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
